module.exports = [
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 192.87
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 193.6
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 189.03
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 167.67
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 160.87
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 170.03
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 185.55
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 92.7
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 97.17
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 103.53
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 105.13
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 109.93
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 125.53
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 139.95
  }
]
